<app-splash-screen></app-splash-screen>
<div
  [ngClass]="{
    'mobile-screen': deviceInfoModel.isMobile,
    'tablet-screen': deviceInfoModel.isTablet,
    'desktop-screen': deviceInfoModel.isDesktop
  }">
  <router-outlet></router-outlet>
</div>
<app-pwa-install-banner></app-pwa-install-banner>
